import { IReviewerStatus } from "@/Washouts/types/PayrollClosing/CommissionCycleClosingReviewers";
import BasicAvatarCard from "../../BasicAvatarCard";
import { ReactNode } from "react";
import { Grid } from "@mui/material";
import { matchPositions } from "@/Common/helpers/Positions";

export interface IReviewer {
	reviewer: IReviewerStatus;
	children?: ReactNode;
	defaultStatus?: string;
}

export const ReviewerCard = ({ reviewer, children, defaultStatus }: Readonly<IReviewer>) => {
	return (
		<Grid item xs={4}>
			<Grid container direction="column">
				<Grid item className="z-[1000]">
					<BasicAvatarCard
						src={reviewer?.picturePath}
						position={matchPositions(reviewer.position)}
						status={reviewer.status ?? defaultStatus}
						name={reviewer.name ?? ""}
						title={reviewer.title ?? ""}
						email={reviewer.email ?? ""}
						phone={reviewer.phone ?? ""}
					/>
				</Grid>
				{children}
			</Grid>
		</Grid>
	);
};
